import { responsive } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  height: `calc(100dvh - ${theme.spacings.xs} * 2)`,
  ...responsive({
    s: {
      height: `calc(100dvh - ${theme.spacings.s} * 2)`,
    },
    m: {
      height: `calc(100dvh - ${theme.spacings.m} * 2)`,
    },
    l: {
      height: `calc(100dvh - ${theme.spacings.l} * 2)`,
    },
  }),
});

export const closeButtonStyle = style({
  pointerEvents: "auto",
});

export const progressBarStyle = style({
  zIndex: 3,
});

export const cardStyle = style({
  width: "auto",
  position: "absolute",
  top: theme.spacings.s,
  left: theme.spacings.s,
  zIndex: 3,
  pointerEvents: "auto",
});

export const messageBannerStyle = style({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  top: "inherit",
});
